<template>
  <user-list
    :title="title"
    csvimport
    userlinks
  />
</template>

<script>

  import userList from '../components/UsersList.vue'

  export default {
    name: 'UserManagement', // this is the name of the component

    components: {
      'user-list': userList,
    },

    computed: {
      title: function () {
        return this.$store.getters.currentUserProfile.account.displayName + ' Users'
      },
    },
  }

</script>
